// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"node_modules_walletconnect_modal_dist_index_js":"d49dff84","defaultVendors-node_modules_walletconnect_modal-ui_dist_index_js":"ab650d0b"}[chunkId] + ".js";
};